import { useMemo } from 'react';
import { EcoLabel } from '~/graphql/__generated__/graphql';
import { StyledEcoLabel } from '../styles/styled-eco-label';

export const EcoLabelElement = ({ ecoLabel }: { ecoLabel: EcoLabel | null | undefined }) => {
	const src = useMemo((): string | null | undefined => {
		if (!ecoLabel) {
			return null;
		}
		if (ecoLabel === 'ECO')
			return 'https://www.audi.es/bin/nemo.static.183336/cms4i-nemo/includes/core-ci/assets/icons/svg/engine-data/eco-label-small.svg';
		if (ecoLabel === 'ZERO')
			return 'https://www.audi.es/bin/nemo.static.183336/cms4i-nemo/includes/core-ci/assets/icons/svg/engine-data/cero-label-small.svg';
		if (ecoLabel === 'ECO_IT')
			return 'https://www.audi.it/bin/nemo.static.183336/cms4i-nemo/includes/core-ci/assets/icons/svg/engine-data/eco-it-label-small.svg';
	}, [ecoLabel]);

	return src ? <StyledEcoLabel alt="Eco Label" src={src} /> : null;
};
